module.exports = __webpack_public_path__ + "img/ACTIVE_SESSIONS.40222e53.svg";